module.exports = __webpack_public_path__ + "img/particle_motion_00090.6970df61.png";